import { coneSparks } from '../effects/factories';
import type { EffectDefinition } from '../effects/types';
import { createModuleIcon } from './icons';
import type { ModulePresentation } from './types';
const OverdriveIcon = createModuleIcon(
	<>
		<path className="module-icon__fill" d="M5 23l8-14 4 7 4-7 7 14h-8l-3-5-3 5z" />
		<path className="module-icon__cut" d="M5 27h22" />
	</>,
);
const color = '#ff5c5c';
const effects: readonly EffectDefinition[] = [
	{
		id: 'module:overdrive:corona',
		lifetime: 0.34,
		layer: 'air',
		render: (frame, painter) => {
			painter.light(frame.x, frame.y, 52 * frame.fout, frame.color, 0.25 * frame.fout);
			for (let index = 0; index < 3; index += 1) {
				painter.polygon(
					frame.x,
					frame.y,
					10 + frame.easeOut(2) * (22 + index * 7),
					3,
					frame.rotation + (index * Math.PI * 2) / 3 + frame.fin * 0.4,
					index === 1 ? '#ffffff' : frame.color,
					frame.fout * (0.9 - index * 0.18),
					2.5 * frame.fout,
				);
			}
		},
	},
	coneSparks({ id: 'module:overdrive:impact', lifetime: 0.38, count: 10, distance: 52, length: 12, stroke: 2 }),
];
export const overdriveModule: ModulePresentation = {
	id: 'overdrive',
	icon: OverdriveIcon,
	meta: {
		color,
		displayColor: '#ff5c5c',
		tint: '#ffebeb',
	},
	effects,
	renderProjectile: ({ ctx, projectile }) => {
		ctx.save();
		ctx.globalAlpha = 0.5;
		ctx.strokeStyle = color;
		ctx.lineWidth = 1.5;
		ctx.beginPath();
		ctx.arc(projectile.position.x, projectile.position.y, projectile.radius + 4, 0, Math.PI * 2);
		ctx.stroke();
		ctx.restore();
	},
};
